"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.showFileLoading = exports.updateUserDocs = exports.changeArea = exports.savePracticeAreas = exports.saveProfile = exports.userLicenseFormChange = exports.userFormChange = exports.showAvatarLoading = exports.toggleProfileLicense = exports.setProfileUser = exports.resetState = exports.toggleProfileEdit = exports.resetPracticeAreas = exports.setFormUpdate = exports.setFirstFlow = exports.fileLoading = exports.setFileError = exports.setOriginUserDocs = exports.setNewDocs = exports.setUserDocs = exports.setGeneralError = exports.toggleDeleteAccount = exports.togglePracticeAreasModal = exports.changePracticeArea = exports.setOldPracticeArea = exports.licenseFormChange = exports.userInfoFormChange = exports.reset = exports.avatarLoading = exports.saveSuccess = exports.toggleLicense = exports.toggleEdit = void 0;
const lodash_1 = __importDefault(require("lodash"));
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const preloaderSlice_1 = require("./preloaderSlice");
const store_1 = __importDefault(require("../store"));
const userFormChange_1 = require("../../widgets/profile/utils/validators/userFormChange");
const userSlice_1 = require("./userSlice");
const serializers_1 = require("../../widgets/profile/utils/serializers");
const common_1 = require("../../utils/common");
const errMessage = '* Email already exists.';
const initialState = {
    editProfile: false,
    addLicense: false,
    profileSaveSuccess: false,
    avatarLoading: false,
    firstFlow: false,
    generalError: false,
    practiceAreaModal: false,
    deleteAccountModal: false,
    guestUser: {},
    userForm: {
        valid: false,
        data: {
            name: {
                required: true,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            bio: {
                required: true,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            pro_bono: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            email: {
                required: true,
                added: false,
                apiError: null,
                origin: null,
                value: null,
                error: null,
                dirty: false
            },
            phone: {
                required: true,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            additional_phone: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            contact_person: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            address: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            full_address: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            city: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            state: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            zipCode: {
                required: false,
                added: false,
                value: null,
                error: null,
                min: 5,
                dirty: false
            },
            hourly_rate: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
        },
        addressGroupError: [],
        changed: false
    },
    licenseForm: {
        valid: false,
        data: {
            state: {
                required: false,
                added: false,
                value: null,
                error: null,
                dirty: false
            },
            license: {
                required: false,
                added: false,
                value: null,
                apiError: null,
                error: null,
                dirty: false
            }
        },
        changed: false
    },
    practiceArea: {
        static: {
            changes: [],
            old: [],
            changed: false,
        },
        temp: {
            changes: [],
            old: [],
            changed: false,
        }
    },
    userDocs: {
        data: [],
        newData: [],
        originData: [],
        fileError: null,
        fileLoading: false
    },
    updated: false
};
const profileSlice = toolkit_1.createSlice({
    name: 'profile',
    initialState: initialState,
    reducers: {
        toggleEdit: (state, action) => {
            state.userForm = action.payload;
            state.editProfile = !state.editProfile;
            state.userDocs.fileError = null;
            return state;
        },
        saveSuccess: (state) => {
            state.profileSaveSuccess = !state.profileSaveSuccess;
            return state;
        },
        toggleDeleteAccount: (state = initialState) => {
            state.deleteAccountModal = !state.deleteAccountModal;
            return state;
        },
        setGeneralError: (state = initialState, action) => {
            state.generalError = action.payload;
            return state;
        },
        toggleLicense: (state, action) => {
            state.addLicense = !state.addLicense;
            return state;
        },
        avatarLoading: (state, action) => {
            state.avatarLoading = action.payload.avatarLoading;
            return state;
        },
        userInfoFormChange: (state = initialState, action) => {
            if (state.generalError) {
                state.generalError = false;
            }
            state.userForm = userFormChange_1.UserFormValid(state.userForm, action.payload);
            return state;
        },
        licenseFormChange: (state = initialState, action) => {
            if (state.generalError) {
                state.generalError = false;
            }
            state.licenseForm = userFormChange_1.LicenseFormValid(state.licenseForm, action.payload);
            return state;
        },
        setFormUpdate: (state = initialState) => {
            state.updated = true;
            return state;
        },
        setFirstFlow: (state, action) => {
            state.firstFlow = action.payload.firstFlow;
            return state;
        },
        reset: (state = initialState) => {
            return Object.assign(Object.assign({}, initialState), { practiceArea: {
                    static: {
                        changes: [],
                        old: state.practiceArea.static.old,
                        changed: false,
                    },
                    temp: {
                        changes: [],
                        old: state.practiceArea.static.old,
                        changed: false,
                    }
                }, userDocs: {
                    data: state.userDocs.originData,
                    newData: [],
                    originData: state.userDocs.data,
                    fileError: null,
                    fileLoading: false
                }, updated: false });
        },
        resetPracticeAreas: (state = initialState) => {
            state.practiceArea = {
                static: {
                    changes: [],
                    old: state.practiceArea.static.old,
                    changed: false,
                },
                temp: {
                    changes: [],
                    old: state.practiceArea.static.old,
                    changed: false,
                }
            };
            return state;
        },
        setOldPracticeArea: (state = initialState, action) => {
            state.practiceArea.static.old = action.payload;
            state.practiceArea.temp.old = action.payload;
            return state;
        },
        changePracticeArea: (state = initialState, action) => {
            if (action.payload.static) {
                state.practiceArea.static = action.payload.static;
            }
            else if (action.payload.temp) {
                state.practiceArea.temp = action.payload.temp;
            }
            return state;
        },
        togglePracticeAreasModal: (state, action) => {
            if (!state.practiceArea.temp.changed) {
                state.practiceArea.temp.changes = [];
            }
            state.practiceAreaModal = !state.practiceAreaModal;
            return state;
        },
        setOriginUserDocs: (state = initialState, action) => {
            state.userDocs.originData = action.payload;
            return state;
        },
        setUserDocs: (state = initialState, action) => {
            state.userDocs.data = action.payload;
            return state;
        },
        setNewDocs: (state = initialState, action) => {
            state.userDocs.newData = action.payload;
            return state;
        },
        setFileError: (state = initialState, action) => {
            state.userDocs.fileError = action.payload;
            return state;
        },
        fileLoading: (state, action) => {
            state.userDocs.fileLoading = action.payload;
        }
    }
});
_a = profileSlice.actions, exports.toggleEdit = _a.toggleEdit, exports.toggleLicense = _a.toggleLicense, exports.saveSuccess = _a.saveSuccess, exports.avatarLoading = _a.avatarLoading, exports.reset = _a.reset, exports.userInfoFormChange = _a.userInfoFormChange, exports.licenseFormChange = _a.licenseFormChange, exports.setOldPracticeArea = _a.setOldPracticeArea, exports.changePracticeArea = _a.changePracticeArea, exports.togglePracticeAreasModal = _a.togglePracticeAreasModal, exports.toggleDeleteAccount = _a.toggleDeleteAccount, exports.setGeneralError = _a.setGeneralError, exports.setUserDocs = _a.setUserDocs, exports.setNewDocs = _a.setNewDocs, exports.setOriginUserDocs = _a.setOriginUserDocs, exports.setFileError = _a.setFileError, exports.fileLoading = _a.fileLoading, exports.setFirstFlow = _a.setFirstFlow, exports.setFormUpdate = _a.setFormUpdate, exports.resetPracticeAreas = _a.resetPracticeAreas;
const toggleProfileEdit = (data) => async (dispatch, getState) => {
    const states = store_1.default.getState().staticData.states;
    const newData = userFormChange_1.SetupUser(lodash_1.default.cloneDeep(initialState.userForm), Object.assign(Object.assign({}, data), { states }));
    const user = getState().user;
    dispatch(exports.toggleEdit(newData));
    dispatch(exports.userInfoFormChange(Object.assign(Object.assign({}, newData), { user })));
};
exports.toggleProfileEdit = toggleProfileEdit;
const resetState = () => dispatch => {
    dispatch(exports.reset());
};
exports.resetState = resetState;
const setProfileUser = (data) => async (dispatch) => {
    dispatch(exports.licenseFormChange(data));
};
exports.setProfileUser = setProfileUser;
const toggleProfileLicense = () => dispatch => {
    dispatch(exports.toggleLicense());
};
exports.toggleProfileLicense = toggleProfileLicense;
const showAvatarLoading = (data) => async (dispatch) => {
    dispatch(exports.avatarLoading(data));
};
exports.showAvatarLoading = showAvatarLoading;
const userFormChange = (action) => async (dispatch, getState) => {
    const user = getState().user;
    dispatch(exports.userInfoFormChange(Object.assign(Object.assign({}, action), { user })));
    window.AppearMe.Widgets.Events.emit('onUserChange', { hide: false });
};
exports.userFormChange = userFormChange;
const userLicenseFormChange = (action) => async (dispatch) => {
    dispatch(exports.licenseFormChange(action));
};
exports.userLicenseFormChange = userLicenseFormChange;
const saveProfile = (data, id, files) => async (dispatch) => {
    var _a, _b, _c;
    try {
        //api validation
        const licenseErr = await checkBar(data.licenseForm, dispatch);
        const emailErr = await checkEmail(data.userForm, dispatch);
        //api validation
        if (licenseErr || emailErr) {
            return common_1.scrollToElemError();
        }
        const userData = serializers_1.UserFormSerializer(data.userForm.data);
        let upload = [];
        if (files.length) {
            dispatch(preloaderSlice_1.showLoader());
            const formData = new FormData();
            for (const f of files) {
                formData.append("file", f);
            }
            upload = (await api_1.Auth.upload('upload-user-files', formData)).data.files;
            dispatch(preloaderSlice_1.hideLoader());
        }
        await api_1.Auth.updateUser(Object.assign(Object.assign({}, userData), { updatedAreas: data.practiceArea.temp.changes, newDocs: [...data.userDocs.newData.filter(i => i.deleted), ...upload] }));
        dispatch(userSlice_1.getUserAllData(id, false));
        dispatch(exports.saveSuccess());
    }
    catch (e) {
        //ToDo remove after fix Same state duplicate logic
        console.log('CATCH', e);
        if ((e === null || e === void 0 ? void 0 : e.message) && e.message === 'Same state duplicate') {
            dispatch(userSlice_1.getUserAllData(id, false));
            dispatch(exports.saveSuccess());
        }
        else if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) != 500) {
            dispatch(exports.setFileError((_c = (_b = e === null || e === void 0 ? void 0 : e.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message));
            dispatch(preloaderSlice_1.hideLoader());
        }
        else {
            dispatch(exports.setGeneralError(errMessage));
        }
    }
};
exports.saveProfile = saveProfile;
const savePracticeAreas = (data, id) => async (dispatch) => {
    if (data.temp.changed) {
        const updated = await api_1.Auth.updatePracticeAreas({ updatedAreas: data.temp.changes });
        dispatch(exports.setOldPracticeArea(updated));
        dispatch(exports.resetPracticeAreas());
    }
};
exports.savePracticeAreas = savePracticeAreas;
const changeArea = (data, type = 'temp', deleted) => async (dispatch) => {
    dispatch(exports.changePracticeArea({ [type]: data }));
    if (deleted) {
        await api_1.Auth.updatePracticeAreas({ updatedAreas: data.changes });
    }
};
exports.changeArea = changeArea;
const checkBar = async (form, dispatch) => {
    if (form.changed && form.valid) {
        const user = api_1.Auth.getStorageUser();
        const res = await userFormChange_1.BarNumberInvalid(user === null || user === void 0 ? void 0 : user.id, form.data.state.value.id, form.data.license.value);
        if (res) {
            dispatch(exports.licenseFormChange({ value: form.data.license.value, field: 'license', apiError: res }));
            return true;
        }
        const licenseData = serializers_1.userLicenseFormSerializer(form.data);
        Object.assign(licenseData, { user: user.id });
        await api_1.Auth.addUserState(licenseData);
    }
};
const checkEmail = async (form, dispatch) => {
    if (form.changed && form.valid && form.data.email.origin !== form.data.email.value) {
        const res = await userFormChange_1.EmailInvalid(form.data.email.value);
        if (res) {
            const user = store_1.default.getState().user;
            dispatch(exports.userInfoFormChange({ value: form.data.email.value, field: 'email', apiError: res, user }));
            return true;
        }
    }
};
const updateUserDocs = (data) => dispatch => {
    dispatch(exports.setUserDocs(data));
};
exports.updateUserDocs = updateUserDocs;
const showFileLoading = (data) => async (dispatch) => {
    dispatch(exports.fileLoading(data));
};
exports.showFileLoading = showFileLoading;
exports.default = profileSlice.reducer;
